// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoUnavailable-cls1_GCU","cls2":"VideoUnavailable-cls2_5Q3 VideoUnavailable-cls1_GCU"};